import { render, staticRenderFns } from "./ScreenAdapter.vue?vue&type=template&id=8aa1ad02&scoped=true"
import script from "./ScreenAdapter.vue?vue&type=script&lang=js"
export * from "./ScreenAdapter.vue?vue&type=script&lang=js"
import style0 from "./ScreenAdapter.vue?vue&type=style&index=0&id=8aa1ad02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa1ad02",
  null
  
)

export default component.exports